import { useState } from 'react';
import { NavDropdown } from 'react-bootstrap';
import Modal from 'react-bootstrap/Modal';
import { Link } from 'react-router-dom';
import { logout } from '../../auth/logoutUtils';

interface LogoutModalProps {
  onItemClick?: () => void;
}

function LogoutModal({ onItemClick }: LogoutModalProps) {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => {
    onItemClick?.();
    setShow(true);
  };

  return (
    <>
      <NavDropdown.Item as="button" onClick={handleShow}>
        Logout
      </NavDropdown.Item>

      <Modal
        show={show}
        onHide={handleClose}
        aria-labelledby="contained-modal-title-vcenter"
        backdrop="static"
        keyboard={false}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Logout</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p id="modalLogOutBodyText">
            You have now successfully logged out, your password is stored for
            when you return.
            <br />
            <br />
            <Link
              className="linkRed"
              to="#"
              onClick={(event) => {
                event.preventDefault();
                void logout(true);
              }}
            >
              Click here
            </Link>{' '}
            if you prefer to sign out completely and remove your account details
            from this computer.
          </p>
        </Modal.Body>
        <Modal.Footer>
          <button
            type="button"
            className="btn btn-secondary"
            id="LogOutCancel"
            data-bs-dismiss="modal"
            onClick={handleClose}
          >
            Cancel
          </button>
          <Link
            to="#"
            className="btn btn-primary"
            id="LogOutContinue"
            onClick={(event) => {
              event.preventDefault();
              void logout(false);
            }}
          >
            Continue
          </Link>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default LogoutModal;
